import { useEffect, useState } from "react";
import { getUserMonthlyDailyAttendanceApi, getMyAttendanceApi } from "../../app/api";
import { useNavigate } from "react-router-dom";
import { User } from "lucide-react";
import { useSearchParams } from "react-router-dom";





export default function MonthlyAttendance() {
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("user_id");


  const IMAGE_BASE_URL = "https://demouptask.visiontrek.io";
  const navigate = useNavigate();

  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);

  const today = new Date();
  const [selectedMonth, setSelectedMonth] = useState(
    `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}`
  );

  const [sortByWorkingHours, setSortByWorkingHours] = useState(false);
  const [year, month] = selectedMonth.split("-");

  useEffect(() => {
    setLoading(true);
    // AdminMonthlyAttendanceApi(Number(month), Number(year))
    const loggedUser = JSON.parse(localStorage.getItem("user"));
    const isOwnProfile = Number(loggedUser?.id) === Number(userId);

    const apiCall = isOwnProfile
      ? getMyAttendanceApi(Number(month), Number(year))
      : getUserMonthlyDailyAttendanceApi(userId, Number(month), Number(year));

    apiCall
      .then((res) => {
        setRecords(res?.success ? res.data || [] : []);
      })
      .finally(() => setLoading(false));
  }, [month, year, userId]);

  const parseSeconds = (time) => {
    if (!time) return 0;
    const [h = 0, m = 0, s = 0] = time.split(":").map(Number);
    return h * 3600 + m * 60 + s;
  };

  // const displayedRecords = sortByWorkingHours
  //   ? [...records].sort(
  //       (a, b) =>
  //         parseSeconds(b.total_working_hours) -
  //         parseSeconds(a.total_working_hours)
  //     )
  //   : records;



  const displayedRecords = [...records].sort((a, b) => {
    // If working hours sort selected
    if (sortByWorkingHours) {
      const diff =
        parseSeconds(b.total_working_hours) -
        parseSeconds(a.total_working_hours);

      // If equal working hours → fallback to alphabetical
      if (diff === 0) {
        return (a.name || "")
          .toLowerCase()
          .localeCompare((b.name || "").toLowerCase());
      }

      return diff;
    }

    // Default → alphabetical sorting
    return (a.name || "")
      .toLowerCase()
      .localeCompare((b.name || "").toLowerCase());
  });





  if (loading)
    return (
      <div className="text-white/70 text-center py-10">
        Loading monthly attendance...
      </div>
    );

  return (
    <div
      className="
      rounded-2xl     mt-5
        md:mt-20 p-5
      bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f]
      text-white border border-white/10 shadow-2xl
    "
    >
      {/* Header */}
      {/* <div className="flex justify-between items-center mb-4">
        <h4 className="font-bold text-xl">
          Monthly Attendance
        </h4>
      </div> */}

      <div className="flex justify-between items-center mb-4">
        <h4 className="font-bold text-xl">
          Monthly Attendance
        </h4>

        {/* ✅ BACK BUTTON */}
        <button
          onClick={() => navigate(-1)}
          className="
      px-3 py-1 text-sm rounded-lg
      bg-white/10 text-white
      border border-white/20
      hover:bg-white/20
      transition
    "
        >
          ← Back
        </button>
      </div>

      <div className="flex  gap-2">

        {/* <select
          value={sortByWorkingHours ? "WORKING_HOURS" : ""}
          onChange={(e) =>
            setSortByWorkingHours(e.target.value === "WORKING_HOURS")
          }
          className=" md:px-3 py-1 rounded-lg 
             bg-[#2d1c6a] 
             text-white 
             border border-white/40 
             text-sm shadow-lg
             focus:outline-none"
        >
          <option value="" className="text-white">
            Sort
          </option>
          <option value="WORKING_HOURS" className="text-white">
            Total Working Hours
          </option>
        </select> */}






        <input
          type="month"
          value={selectedMonth}
          onChange={(e) => setSelectedMonth(e.target.value)}
          className="md:px-3  py-1 rounded-lg bg-white/100 text-black border border-white/20 text-sm"
        />
      </div>
      {/* </div> */}

      {/* Table */}
      <div className="max-h-[450px] overflow-y-auto">
        <table className="w-full text-sm table-fixed">
          <thead className="text-white/70 border-b border-white/10 ">
            <tr>
              <th className="text-left w-[260px] py-3 px-3">Date</th>
              <th className=" text-left w-[90px] py-3 px-3">Status</th>
              <th className=" text-left w-[90px] py-3 px-3">Punch In</th>
              <th className=" text-left w-[160px] py-3 px-3">Punch Out</th>
              <th className=" text-left w-[140px] py-3 px-3">Working</th>
              <th className=" text-left w-[140px] py-3 px-3">Extra</th>

              <th className=" text-left w-[140px] py-3 px-3">Break</th>
              <th className=" text-left w-[140px] py-3 px-3">Early Out</th>
            </tr>
          </thead>

          {/* <tbody>
            {displayedRecords.length > 0 ? (
              displayedRecords.map((row) => (
                <tr
                  key={row.user_id}
                  className="border-b border-white/5 hover:bg-white/5"
                >
                  <td className="w-[260px] py-3 px-3">
                    <div
                      className="flex items-center gap-3 cursor-pointer"
                      onClick={() =>
                        navigate(`/users/${row.user_id}`)
                      }
                    >
                      <div className="w-10 h-10 rounded-full bg-white/10 overflow-hidden flex items-center justify-center">
                        {row.profile_pic ? (
                          <img
                            src={`${IMAGE_BASE_URL}${row.profile_pic}`}
                            className="w-full h-full object-cover"
                          />
                        ) : (
                          <User size={18} className="text-white/50" />
                        )}
                      </div>

                      <span className="font-medium truncate text-blue-300">
                        {row.NAME || "—"}
                      </span>
                    </div>
                  </td>

                  <td className="py-3 px-3">
                    <span className="px-3 py-1 rounded-full bg-green-500/20 text-green-300 text-xs">
                      {row.present_days}
                    </span>
                  </td>

                  <td className="py-3 px-3">
                    <span className="px-3 py-1 rounded-full bg-red-500/20 text-red-300 text-xs">
                      {row.absent_days}
                    </span>
                  </td>

                  <td className="py-3 px-3 text-blue-300 font-mono">
                    {row.total_working_hours || "—"}
                  </td>

                  <td className="py-3 px-3 text-purple-300 font-mono">
                    {row.extra_hours ? row.extra_hours.split(".")[0] : "—"}

                  </td>


                  <td className="py-3 px-3 text-yellow-300 font-mono">
  {row.total_break_time ? row.total_break_time.split(".")[0] : "—"}
</td>

<td className="py-3 px-3 text-red-300 font-mono">
  {row.total_early_time ? row.total_early_time.split(".")[0] : "—"}
</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="py-6 text-center opacity-60">
                  No Monthly Records Found
                </td>
              </tr>
            )}
          </tbody> */}




          <tbody>
            {displayedRecords.length > 0 ? (
              displayedRecords.map((row, index) => (
                <tr
                  key={index}
                  className="border-b border-white/5 hover:bg-white/5"
                >
                  {/* Date */}
                  <td className="py-3 px-3 text-blue-300">
                    {row.attendance_date || "—"}
                  </td>

                  {/* Status */}
                  <td className="py-3 px-3">
                    <span
                      className={`px-3 py-1 rounded-full text-xs ${row.STATUS === "Present"
                        ? "bg-green-500/20 text-green-300"
                        : row.STATUS === "Casual"
                          ? "bg-yellow-500/20 text-yellow-300"
                          : "bg-red-500/20 text-red-300"
                        }`}
                    >
                      {row.STATUS || "—"}
                    </span>
                  </td>

                  {/* Punch In */}
                  <td className="py-3 px-3 text-white/80">
                    {row.punch_in || "—"}
                  </td>

                  {/* Punch Out */}
                  <td className="py-3 px-3 text-white/80">
                    {row.punch_out || "—"}
                  </td>

                  {/* Working */}
                  <td className="py-3 px-3 text-blue-300 font-mono">
                    {row.working_hours || "—"}
                  </td>

                  {/* Extra */}
                  <td className="py-3 px-3 text-purple-300 font-mono">
                    {row.extra_hours || "—"}
                  </td>

                  {/* Break */}
                  <td className="py-3 px-3 text-yellow-300 font-mono">
                    {row.break_minutes != null
                      ? `${row.break_minutes} min`
                      : "—"}
                  </td>

                  {/* Early Out */}
                  <td className="py-3 px-3 text-red-300 font-mono">
                    {row.early_out ? "Yes" : "No"}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="py-6 text-center opacity-60">
                  No Records Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}